export default __webpack_public_path__ + "static/media/icon-monCompte-cursus.91d980ad.svg";